module.exports = __webpack_public_path__ + "img/whatsapp-churchplus.859b790b.svg";